import { isObject } from "@atlassiansox/bxp-shared-utils";

import { Attachment, isAttachment } from "./attachment";
import { BlendMode, isBlendMode } from "./blend-mode";
import { Breakpoint, isBreakpoint } from "./breakpoint";
import { Clip, isClip } from "./clip";
import { Image, isImage } from "./image";
import { Origin, isOrigin } from "./origin";
import { Position, isPosition } from "./position";
import { Repeat, isRepeat } from "./repeat";
import { Size, isSize } from "./size";

export type Properties = {
    attachment: Attachment;
    blendMode: BlendMode;
    clip: Clip;
    image: Image;
    origin: Origin;
    position: Position;
    repeat: Repeat;
    size: Size;
};

export function isProperties(value: unknown): value is Properties {
    if (!isObject(value)) {
        return false;
    }

    const temp = value as Properties;

    return (
        isAttachment(temp.attachment) &&
        isBlendMode(temp.blendMode) &&
        isClip(temp.clip) &&
        isImage(temp.image) &&
        isOrigin(temp.origin) &&
        isPosition(temp.position) &&
        isRepeat(temp.repeat) &&
        isSize(temp.size)
    );
}

export type BackgroundField = {
    breakpoints: Breakpoint[];
    color: string;
    properties: Properties[];
};

export function isBackgroundField(value: unknown): value is BackgroundField {
    if (!isObject(value)) {
        return false;
    }

    const temp = value as BackgroundField;

    return (
        Array.isArray(temp.breakpoints) &&
        temp.breakpoints.every((breakpoint) => isBreakpoint(breakpoint)) &&
        typeof temp.color === "string" &&
        Array.isArray(temp.properties) &&
        temp.properties.every((property) => isProperties(property))
    );
}

export function isBackgroundFieldArray(
    value: unknown
): value is BackgroundField[] {
    if (!Array.isArray(value) || value.length < 1) {
        return false;
    }

    return value.every((item) => isBackgroundField(item));
}
